// extracted by mini-css-extract-plugin
export default {"statRow":"EnergyManagementPage_statRow__EAqq8","cardRow":"EnergyManagementPage_cardRow__2p+th","footnote":"EnergyManagementPage_footnote__pZcXA"};